import { render, staticRenderFns } from "./HistorySheetDetails.vue?vue&type=template&id=5ca707f6&scoped=true"
import script from "./HistorySheetDetails.vue?vue&type=script&lang=js"
export * from "./HistorySheetDetails.vue?vue&type=script&lang=js"
import style0 from "./HistorySheetDetails.vue?vue&type=style&index=0&id=5ca707f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca707f6",
  null
  
)

export default component.exports